<template>
  <div class="home main">
    <van-sticky>
      <div class="header">
        <!-- <span class="title">访客动态</span> -->
        <div class="tabs">
          <div v-for="item in typeTabs" :key="item.type" @click="changetabType(item.type)" :class="{ tab: true, active: item.type == searchParams.tabType }" class="ok-bg-active">
            {{ item.val }}
          </div>
        </div>
        <img class="icon-search" @click="search" src="@static/images/business/icon_search_black.png" alt="" />
      </div>
      <div class="sub-header">
        <van-tabs
          :ellipsis="false"
          color="#236DFF"
          line-width="40px"
          line-height="3px"
          @click="changeTab"
          title-active-color="#17233D"
          title-inactive-color="#515A6E"
        >
          <van-tab v-for="(item, index) in tabs" :title="item.val" :key="index"> </van-tab>
        </van-tabs>
      </div>
    </van-sticky>
    <van-pull-refresh v-model="refreshing" @refresh="onReferesh">
      <van-list v-if="list.length" v-model="loading" :finished="finished" finished-text="没有更多了" @load="nextPage">
        <div v-for="customer in list" :key="customer.id">
          <div v-if="searchParams.tabType == 1" class="list" @click="toDetail(customer, 1)">
            <div class="visitor-box">
              <div class="customer f">
                <img class="img-head" :src="customer.imgUrl" alt="" />
                <div class="content f-col">
                  <span>{{ customer.nickname }}</span>
                  <span>{{ customer.createTime | formatTime('MM-DD HH:mm') }}</span>
                </div>
                <span v-if="customer.time" class="time">阅读{{ customer.time }}</span>
              </div>
              <!-- 名片类型 -->
              <div class="info" v-if="customer.type==7">查看了我的电子名片</div>
              <div class="info" v-else-if="customer.type==8">查看了我的个人微店</div>
              <div class="info" v-else-if="customer.type==9">查看了我的预约顾问</div>
              <div class="info" v-else>查看了{{ VISIT_TYPE[customer.type] }}《{{ customer.name }}》</div>
              <span v-if="customer.customerId" class="tip">客户</span>
            </div>
          </div>
          <div v-else-if="searchParams.tabType == 2" @click="toDetail(customer, 2)">
            <div class="customer-record-box">
              <div class="cover">
                <img v-if="customer.typeImg" class="cover-img" :src="customer.typeImg" alt="" />
                <img v-else class="icon" :src="typeImg[customer.type]" alt="" />
                <span class="name">{{ VISIT_TYPE[customer.type] }}</span>
              </div>
              <div class="content">
                <p class="info" v-if="customer.type==8">我的个人微店</p>
                <p class="info" v-else-if="customer.type==9">我的预约顾问留资页面</p>
                <p class="info" v-else>{{ customer.name }}</p>
                <p class="time-wrap f-b">
                  <span class="f"
                    ><img :src="customer.imgUrl" alt="" /><span class="cus-name">{{ customer.nickname }}&nbsp;</span>{{ customer.counts > 1 ? '等' : ''
                    }}<span v-if="customer.counts > 1" blue>{{ customer.counts }}</span> <span v-if="customer.counts > 1">人</span> 来访</span
                  ><span class="time">
                    {{ customer.createTime | formatTime('MM-DD HH:mm') }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </van-list>
      <div v-else class="empty-box">
        <img src="@static/images/business/empty_3.png" alt="" />
        <p>暂无访客数据</p>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import { loading, common } from '@/api/mixins';
import filter from '@/api/filter';
export default {
  name: 'apps.business.visitor',
  mixins: [loading, common],
  data() {
    return {
      typeTabs: [
        {
          type: 1,
          val: '按访客展示'
        },
        {
          type: 2,
          val: '按内容展示'
        }
      ],
      typeImg: {
        2: require('@static/images/business/icon_planbook.png'), //计划书
        7: require('@static/images/business/icon_card.png'), //名片
        8: require('@static/images/business/icon_wd.png'), //微店
        9: require('@static/images/business/icon_yygw.png') //预约顾问
        // 4: require('@static/images/business/icon_text.png'), //托管报告
      },
      tabs: [
        { val: '全部', key: '' },
        { val: '产品', key: '1' },
        { val: '计划书', key: '2' },
        { val: '资讯文章', key: '3' },
        { val: '电子名片', key: '7' },
        { val: '个人微店', key: '8' },
        { val: '预约顾问', key: '9' },
      ],
      list: [],
      isSearch: false,
      refreshing: false, //下拉刷新
      finished: true, //是否完成上拉加载
      searchParams: {
        //列表查询参数
        type: '', //访问类型 字典 key VISIT_TYPE 获取
        tabType: 1, //apptab栏类型,@notes1-按访客展示2-按内容展示
        pageSize: 20,
        pageNo: 1
      },
      totalNo: '', //总页数
      VISIT_TYPE: {}
    };
  },
  created() {
    //查字典 获取tabs
    this.getDicByType({
      type: 'VISIT_TYPE'
    }).then(res => {
      this.VISIT_TYPE = res;
    });
  },
  activated() {
    let vm = this;
    if (this.$config.isApp) {
      //app环境右上角展示 客户列表 快捷入口
      this.$app.toShowTitle('客户列表', () => {
        vm.linkCustomer();
      });
    }
    this.getList(false);
  },
  deactivated() {
    if (this.$config.isApp) {
      //app环境右上角展示 客户列表 快捷入口
      this.$app.hideRightIcon();
    }
  },
  beforeDestroy() {},
  methods: {
    linkCustomer() {
      this.$router.push({
        path: '/apps/business/customer',
        query: {
          type: 0
        }
      });
    },
    search() {
      this.$router.push({
        path: '/apps/business/searchVisitor'
      });
    },
    //上拉加{载
    nextPage() {
      if (this.searchParams.pageNo == this.totalNo) {
        this.finished = true;
        return;
      }
      this.searchParams.pageNo++;
      this.getList(false);
    },
    //切换列表类型
    changetabType(res) {
      // if (this.searchParams.tabType === res) {
      this.refreshing = true;
      // }
      this.searchParams.pageNo = 1;
      this.searchParams.tabType = res;
      this.getList(false);
    },
    //切换tab
    changeTab(res) {
      if (this.searchParams.type === this.tabs[res].key) {
        this.refreshing = true;
      }
      this.searchParams.pageNo = 1;
      this.searchParams.type = this.tabs[res].key;
      this.getList(false);
    },
    //下拉刷新
    onReferesh() {
      this.refreshing = true;
      this.searchParams.pageNo = 1;
      this.getList(false);
    },
    getList(loading = true) {
      this.loading = loading;
      this.$http({
        type: 'POST',
        url: '/app/visitRecord/list',
        data: this.searchParams
      })
        .then(res => {
          this.searchParams.pageNo = res.current;
          this.totalNo = res.pages;
          if (res.current == 1) {
            this.list = [];
          }
          this.list = [...this.list, ...res.data].map(item => {
            if (item.visitTime) {
              item.time = this.$tools.formatSeconds(item.visitTime);
            }
            return item;
          });
          this.refreshing = false;
          this.loading = false;
          if (res.current === res.pages) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        })
        .catch(() => {
          this.loading = false;
          this.refreshing = false;
          this.finished = true;
        });
    },
    toDetail(info, type) {
      if (type == 1) {
        //按访客
        this.$router.push({
          name: 'apps.business.visitorDetail',
          query: {
            visitorId: info.visitorId,
            type: this.searchParams.type
          }
        });
      } else {
        //按内容
        this.$router.push({
          name: 'apps.business.contentVisitDetail',
          query: {
            typeId: info.typeId,
            type: this.searchParams.type
          }
        });
      }
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped>
.empty-box {
  text-align: center;

  img {
    width: 420px;
    margin: 106px 0 40px;
  }

  p {
    font-size: 28px;
    line-height: 40px;
    color: #727c8e;
  }
}

/deep/.van-sticky {
  background: linear-gradient(180deg, #fefefe 0%, #f5f7fa 100%);
}

.main {
  min-height: 100vh;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  padding: 30px 30px 14px;
  align-items: center;
  justify-content: space-between;

  .tabs {
    display: flex;
    overflow: hidden;
    text-align: center;
    font-size: 26px;
    font-weight: 400;
    color: #515a6e;
    line-height: 56px;

    .tab {
      flex: 0 0 160px;
      width: 160px;
      height: 56px;
      border: 1px solid #dddddd;
    }

    & :first-child {
      border-right: none;
      border-radius: 3px 0 0 3px;
    }

    & :last-child {
      border-radius: 0 3px 3px 0;
    }

    .active {
      background-color: #236dff;
      color: #ffffff;
      border-color: #236dff;
    }
  }

  .icon-search {
    width: 35px;
    height: 35px;
  }

  .title {
    flex: 1;
    font-size: 34px;
    font-weight: 600;
    line-height: 48px;
    color: #13233f;
  }

  /deep/.van-tabs__wrap {
    flex: 0 0 320px;
    width: 320px;

    .van-tabs__nav--card {
      border-color: #dddddd !important;
      margin: 0;
      border-radius: 3px;
      font-size: 26px;

      .van-tab {
        // border-color: #DDDDDD !important;

        color: #515a6e;
      }

      .van-tab--active {
        border-color: #236dff !important;
      }
    }
  }

  /deep/.van-tabs .van-tab--active .van-tab__text {
    font-size: 26px;
    color: #ffffff;
    // padding: 0 15px;
    font-weight: 400;
  }

  /deep/.van-tabs .van-tab__text {
    font-size: 26px;
    color: #515a6e;
  }
}

/deep/.van-pull-refresh {
  flex: 1;
}
.sub-header {
  padding: 0 4px;
  border-bottom: 1px solid #dfe5ed;

  /deep/.van-tabs__wrap {
    height: 90px;
  }

  /deep/.van-tabs {
    border-bottom: none;

    .van-tabs__nav {
      background-color: transparent;
    }
  }

  /deep/.van-tabs .van-tab--active .van-tab__text {
    font-size: 30px;
    font-weight: 600;
    color: #17233d;
  }

  /deep/.van-tab {
    margin: 0 23px;
  }

  /deep/.van-tabs__line {
    bottom: 0;
  }

  /deep/.van-tabs .van-tab__text {
    font-size: 30px;
    color: #515a6e;
  }
}

.list {
  .visitor-box {
    width: 690px;
    // height: 220px;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    margin: 20px auto;
    position: relative;
    padding-bottom: 20px;

    .customer {
      padding: 26px 32px 26px 28px;
      .img-head {
        flex: 0 0 86px;
        width: 86px;
        height: 86px;
        border-radius: 50%;
        margin-right: 14px;
        border-radius: 50%;
      }

      .content {
        flex: 1;

        & :first-child {
          font-size: 30px;
          line-height: 42px;
          color: #17233d;
        }

        & :last-child {
          font-size: 26px;
          line-height: 31px;
          color: #8e96a5;
          margin-top: 10px;
        }
      }

      .time {
        font-size: 26px;
        line-height: 31px;
        color: #727c8e;
        margin-right: 1px;
        margin-top: 50px;
      }
    }

    .info {
      font-size: 28px;
      line-height: 40px;
      max-height: 100px;
      color: #17233d;
      padding: 20px 30px 0px;
      border-top: 1px solid #ececec;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }

    .tip {
      position: absolute;
      width: 80px;
      height: 40px;
      background: linear-gradient(135deg, #23aaff 0%, #2378ff 100%);
      opacity: 1;
      border-radius: 0px 10px 0px 10px;
      font-size: 24px;
      line-height: 40px;
      color: #ffffff;
      text-align: center;
      right: 0;
      top: 0;
    }
  }
}

/deep/.van-list__finished-text {
  font-size: 24px;
  line-height: 33px;
  color: #aaaaaa;
  padding: 30px 0;
}

.customer-record-box {
  display: flex;
  border-bottom: 1px solid #dfe5ed;
  padding: 30px 0;
  margin: 0 30px;

  .cover {
    position: relative;
    text-align: center;
    width: 150px;
    height: 150px;
    background: #ffffff;
    border-radius: 10px;
    overflow: hidden;
    margin-right: 20px;

    .icon {
      width: 50px;
      margin-top: 30px;
    }

    .cover-img {
      width: 100%;
      height: 100%;
    }

    .name {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      width: 150px;
      height: 42px;
      background: #e7effd;

      font-size: 24px;
      line-height: 42px;
      text-align: center;
      color: #2e4f96;
    }
  }

  .content {
    height: 150px;
    display: flex;
    flex-direction: column;

    .info {
      flex: 0 0 80px;
      width: 520px;
      font-size: 30px;
      line-height: 40px;
      color: #17233d;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    .time-wrap {
      margin-top: 10px;
      font-size: 26px;
      line-height: 40px;
      color: #727c8e;
      margin-top: 28px;

      .cus-name {
        color: #17233d;
      }

      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 8px;
      }
    }
  }
}

.f {
  display: flex;
  align-items: center;
}

.f-b {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.f-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.f-c {
  display: flex;
  align-items: center;
  justify-content: center;
}

*[blue] {
  color: #236dff;
}
</style>
